<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-head"><span class="strong">Maps</span></h2>
<p class="img_container"><a id="page_viii"></a><a id="page_ix"><img alt="image" src="images/pagexi.jpg"/></a></p><a id="page_ix">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Maps.vue?6aeb4993